// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.deal-card-title {
    font-size: 1.4em;
}

@media (max-width: 576px) {
    .deal-card-title {
        font-size: 1.75em;
    }
}

.deal-card-content{
    min-height: 175px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/deal-card-styles.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["\n.deal-card-title {\n    font-size: 1.4em;\n}\n\n@media (max-width: 576px) {\n    .deal-card-title {\n        font-size: 1.75em;\n    }\n}\n\n.deal-card-content{\n    min-height: 175px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
